export function getUrlArrayString(paramName: string, array: any[]): string {
  let stringValue = '';
  for (let i = 0; i < array.length; i++) {
    stringValue += `&${paramName}[${i}]=${array[i]}`;
  }
  return stringValue;
}
